import { AbstractControl } from '@angular/forms';

export function checkIfCheckboxIsSelected(formControl: AbstractControl) {
  const selectedValues = formControl.value;
  const noOptionsSelected = !Array.isArray(selectedValues) || selectedValues.length === 0;
  return noOptionsSelected ? { 'required': true } : null;
}
